import { PlaceRating } from '@tgg/common-types';
import { GymDto } from '@tgg/services';
import { getAbsoluteURL } from '@tgg/util';

import { LocalBusinessData } from './GymPage.types';

export function getLocalBusinessData(
    gym: GymDto,
    photoUrls: string[],
    gymRating: PlaceRating | null,
): LocalBusinessData {
    const absoluteLogoSource = getAbsoluteURL('/ywnqh/images/tgg_logo.svg');

    const address2 = gym.address.address2?.trim();
    const streetAddress = address2
        ? `${gym.address.address1.trim()}, ${address2}`
        : gym.address.address1.trim();

    const localBusinessData: LocalBusinessData = {
        '@context': 'https://schema.org',
        '@type': 'ExerciseGym',
        name: `The Gym Group ${gym.name}`,
        address: {
            '@type': 'PostalAddress',
            streetAddress,
            addressLocality: gym.address.city,
            postalCode: gym.address.postcode,
            addressCountry: 'GB',
        },
        geo: {
            '@type': 'GeoCoordinates',
            latitude: gym.latitude,
            longitude: gym.longitude,
        },
        openingHoursSpecification: [
            {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: ['Monday'],
                opens: gym.openingHours.monday.openingTime,
                closes: gym.openingHours.monday.closingTime,
            },
            {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: ['Tuesday'],
                opens: gym.openingHours.tuesday.openingTime,
                closes: gym.openingHours.tuesday.closingTime,
            },
            {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: ['Wednesday'],
                opens: gym.openingHours.wednesday.openingTime,
                closes: gym.openingHours.wednesday.closingTime,
            },
            {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: ['Thursday'],
                opens: gym.openingHours.thursday.openingTime,
                closes: gym.openingHours.thursday.closingTime,
            },
            {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: ['Friday'],
                opens: gym.openingHours.friday.openingTime,
                closes: gym.openingHours.friday.closingTime,
            },
            {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: ['Saturday'],
                opens: gym.openingHours.saturday.openingTime,
                closes: gym.openingHours.saturday.closingTime,
            },
            {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: ['Sunday'],
                opens: gym.openingHours.sunday.openingTime,
                closes: gym.openingHours.sunday.closingTime,
            },
        ],
        logo: absoluteLogoSource,
    };

    if (photoUrls && photoUrls.length > 0) {
        localBusinessData.image = photoUrls[0];
    }

    const photos = photoUrls?.slice(1);

    if (photos && photos.length > 0) {
        localBusinessData.photo = photos;
    }

    if (gymRating?.rating && gymRating?.userRatingsTotal) {
        localBusinessData.aggregateRating = {
            '@type': 'AggregateRating',
            ratingValue: gymRating?.rating,
            reviewCount: gymRating?.userRatingsTotal,
            bestRating: 5,
            worstRating: 1,
        };
    }

    return localBusinessData;
}
